import { sanitizeTextForComparison } from './sanitizeTextForComparison';

export default function searchTextThemeWeight(searchText, theme) {
  if (!searchText) {
    return 1;
  }
  const nameMult = 4;
  const shortDescriptionMult = 3;
  const activityNameMult = 1;
  const exactNameOffset = 10000;
  const partialNameOffset = 7500;
  const partialShortDescriptionOffset = 5000;
  const exactActivityNameOffset = 2500;
  const partialActivityNameOffset = 1000;

  searchText = sanitizeTextForComparison(searchText);
  const searchWords =
    searchText.length == 1
      ? [searchText]
      : searchText.split(' ').filter((word) => word.length > 1);

  const maxAccWeight =
    searchWords.reduce((acc, word) => acc + word.length, 0) *
    (nameMult * 2 + shortDescriptionMult * 2);

  const sanitized = {
    englishName: sanitizeTextForComparison(theme.englishName),
    name: sanitizeTextForComparison(theme.name),
    shortDescription: sanitizeTextForComparison(theme.shortDescription),
    activities:
      theme.activities?.map((activity) => ({
        id: activity.id,
        englishName: sanitizeTextForComparison(activity.englishName),
        name: sanitizeTextForComparison(activity.name),
      })) || [],
  };

  const exactName =
    sanitized.englishName === searchText || sanitized.name === searchText;
  const partialMatchName =
    sanitized.englishName.includes(searchText) ||
    sanitized.name.includes(searchText);
  const partialMatchShortDescription =
    sanitized.shortDescription.includes(searchText);
  const exactMatchActivityName = sanitized.activities.some(
    (activity) =>
      activity.englishName === searchText || activity.name === searchText
  );
  const partialMatchActivityName = sanitized.activities.some(
    (activity) =>
      activity.englishName.includes(searchText) ||
      activity.name.includes(searchText)
  );

  let totalWeight = 0;
  if (exactName) {
    totalWeight = exactNameOffset + maxAccWeight;
  } else if (partialMatchName) {
    totalWeight = partialNameOffset + maxAccWeight;
  } else if (partialMatchShortDescription) {
    totalWeight = partialShortDescriptionOffset + maxAccWeight;
  } else if (exactMatchActivityName) {
    totalWeight = exactActivityNameOffset + maxAccWeight;
  } else if (partialMatchActivityName) {
    totalWeight = partialActivityNameOffset + maxAccWeight;
  } else {
    let englishNameWeight = 0;
    let nameWeight = 0;
    let activityNameWeight = 0;
    let shortDescriptionWeight = 0;
    totalWeight = searchWords.reduce((accWeight, word) => {
      englishNameWeight = sanitized.englishName.includes(word)
        ? word.length
        : 0;
      nameWeight = sanitized.name.includes(word) ? word.length : 0;
      shortDescriptionWeight = sanitized.shortDescription.includes(word)
        ? word.length
        : 0;
      activityNameWeight = sanitized.activities.reduce(
        (accActivityWeight, activity) => {
          const activityEnglishNameWeight = activity.englishName.includes(word)
            ? word.length
            : 0;
          const activityNameWeight = activity.name.includes(word)
            ? word.length
            : 0;
          return (
            accActivityWeight +
            (activityEnglishNameWeight + activityNameWeight) * activityNameMult
          );
        },
        0
      );
      return (
        accWeight +
        (englishNameWeight + nameWeight) * nameMult +
        shortDescriptionWeight * shortDescriptionMult +
        activityNameWeight * activityNameMult
      );
    }, 0);
  }

  return totalWeight;
}
